export interface IFeatureFlags {
  CONCESSIONS?: boolean
  MERCHANDISE?: boolean
  RESERVATIONS?: boolean
}

export const featureFlags: IFeatureFlags = {
  CONCESSIONS: process.env.NEXT_PUBLIC_CONCESSIONS_ENABLED === 'true',
  MERCHANDISE: process.env.NEXT_PUBLIC_MERCHANDISE_ENABLED === 'true',
  RESERVATIONS: process.env.NEXT_PUBLIC_RESERVATIONS_ENABLED === 'true'
}

export default featureFlags
